var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hinava_random_uuid_333150290152082239412806111186539280107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1591 14.6605L19.8181 22.9996H10.25C9.00688 22.9996 8 24.0065 8 25.2496V38.7496C8 39.9918 9.00688 40.9996 10.25 40.9996H19.8181L28.1591 49.3387C29.5681 50.7477 32 49.7577 32 47.7477V16.2515C32 14.2396 29.5662 13.2534 28.1591 14.6605ZM51.2788 31.9996L55.5575 27.7209C56.1481 27.1302 56.1481 26.1721 55.5575 25.5815L53.4181 23.4421C52.8275 22.8515 51.8694 22.8515 51.2788 23.4421L47 27.7209L42.7212 23.4421C42.1306 22.8515 41.1725 22.8515 40.5819 23.4421L38.4425 25.5815C37.8519 26.1721 37.8519 27.1302 38.4425 27.7209L42.7212 31.9996L38.4434 36.2774C37.8528 36.868 37.8528 37.8262 38.4434 38.4168L40.5828 40.5562C41.1734 41.1468 42.1316 41.1468 42.7222 40.5562L47 36.2784L51.2788 40.5571C51.8694 41.1477 52.8275 41.1477 53.4181 40.5571L55.5575 38.4177C56.1481 37.8271 56.1481 36.869 55.5575 36.2784L51.2788 31.9996Z",
    fill: "url(#hinava_random_uuid_156165660128130925788625882328946835592)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_156165660128130925788625882328946835592",
    x1: 32.0002,
    y1: 14,
    x2: 32.0002,
    y2: 49.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hinava_random_uuid_333150290152082239412806111186539280107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMute);
export default __webpack_public_path__ + "static/media/sound-mute.43d89989c0d607582bf61b9365063267.svg";
export { ForwardRef as ReactComponent };